<script lang="ts">
    import { Col ,Modal ,ModalHeader, ModalBody, Button, ModalFooter} from "sveltestrap";
    import { Close, Detail2, Newmessage, Sendmessage } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
</script>
<Col sm="12">
    <Card cardHeaderprops="pb-0" headerTitle="Static Example">
        <div slot="contentbody">
            <Modal static isOpen>
                <ModalHeader>
                    {Newmessage}
                </ModalHeader>
                <ModalBody>
                    {Detail2}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary">{Close}</Button>
                    <Button color="primary">{Sendmessage}</Button>
                </ModalFooter>
            </Modal>
        </div> 
    </Card>
</Col>